









































import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PageInitialMixin from "@/mixins/PageInitialMixin";

// 内容层级           
import ContentLayer from '@/layers/ContentLayer.vue';
import ScanTitle from "@/components/common/index/ScanTitle.vue";
import BarrageIndex from "@/components/common/index/BarrageIndex.vue";
import ActivityMainImageIndex from "@/components/common/index/ActivityMainImage.vue";
import CourseDetail from '@/components/common/index/CourseDetail.vue';
import ActivityLink from "@/components/common/index/ActivityLink.vue";



import DistributeTopSection from "./components/index/DistributeTopSection.vue";
import DistributeTabBar from "./components/index/DistributeTabBar.vue";
import DistributeParticipant from "./components/index/DistributeParticipant.vue";
import DistributeParticipantModal from "./components/index/DistributeParticipantModal.vue";



// 图标层级
import IconLayer from '@/layers/IconLayer.vue';
import BGMIcon from "@/components/common/index/BGMIcon.vue";
import ContactIcon from "@/components/common/index/ContactIcon.vue";
import PosterIcon from "@/components/common/index/PosterIcon.vue";
import ShareIcon from "@/components/common/index/ShareIcon.vue";
import RecruitIcon from '@/components/common/index/RecruitIcon.vue';
import InviteIcon from '@/components/common/index/InviteIcon.vue';
import MicroWebsiteIcon from '@/components/common/index/MicroWebsiteIcon.vue';

// 底部按钮层级
import FooterLayer from '@/layers/FooterLayer.vue';
import OneClickFooter from '@/components/common/index/OneClickFooter.vue';
import EditFooter from "@/components/common/edit/EditFooter.vue";
import DistributeFooter from "./components/index/DistributeFooter.vue";
import UserAgreementModal from "./components/edit/UserAgreement.vue";
import DemoFooter from "@/components/common/index/DemoFooter.vue";

// Mask层级
import MaskLayer from '@/layers/MaskLayer.vue';

import getUrlParam from '@/common/utils/getUrlParam';
import fetch from "@/common/api/fetch";
import { AxiosPromiseData, AxiosPromiseError } from "@/common/interface";

@Component({
  components: {
    "content-layer": ContentLayer,
    "scan-title": ScanTitle,
    "barrage-index": BarrageIndex,
    "activity-main-image-index": ActivityMainImageIndex,
    "distribute-top-section":DistributeTopSection,
    "distribute-tabbar":DistributeTabBar,

    "course-detail": CourseDetail,

 
    "distribute-participant":DistributeParticipant,
    "activity-link": ActivityLink,
    "icon-layer": IconLayer,
    "bgm-icon": BGMIcon,
    "contact-icon": ContactIcon,
    "poster-icon": PosterIcon,
    "share-icon": ShareIcon,
    "recruit-icon": RecruitIcon,
    "invite-icon": InviteIcon,
    "microWebsite-icon": MicroWebsiteIcon,


    "footer-layer": FooterLayer,
    "edit-footer": EditFooter,
    "dstribute-participant-modal":DistributeParticipantModal,
    "distribute-footer":DistributeFooter,
    "user-agreement-modal": UserAgreementModal,
    "mask-layer": MaskLayer,
    "one-click-footer": OneClickFooter,

    "demo-footer": DemoFooter,
  }
})
export default class DistributeIndex extends Mixins(PageInitialMixin) {
  @Getter("showBarrage") showBarrage!: boolean;
  @Getter("showData") showData!: boolean;
  @Getter("mainBackgroundColor") mainBackgroundColor!: string;
  @Getter("showWesiteBtn") showWesiteBtn!: boolean;
  @Getter("showWantDo") showWantDo!: boolean;
  @Getter("showNum") showNum!: boolean;
  @Getter("distributeTypeParameter") distributeTypeParameter!: Object;
  @Getter("uid") uid!: string;
  @Getter("hasPay") hasPay!: number;
  @Getter("startTime") startTime: any;  
  @Getter("deadline") deadline!: number;
  @Getter("cancel") cancel!: boolean;

  participantModalShow: boolean = false;
  type: string = getUrlParam("type") as string;
  showScanTitle: boolean = false;
  activityStatus: string = "";

  mounted() {
    setTimeout(() => {
      this.showScanTitle = this.showData == undefined ? true : this.showData;
    }, 2000);
  }
  
  showParticipantModal(){
    this.participantModalShow = true;
  }
  hideParticipantModal(){
    this.participantModalShow = false;
  }
    getActivityStatus(){
      const activityDeadline: number = this.deadline;
      const activityStartTime: number = this.startTime;
      const nowTimestamp: number = new Date().valueOf();
      if(activityStartTime > nowTimestamp){
        this.activityStatus = "noStart";
      }else{
        if(nowTimestamp<activityDeadline){
          this.activityStatus = "startIng";
        }else{
          this.activityStatus = "endIng";
        }
      }
    }

}
